import React from 'react'
import { Box, Stack, Text, Columns, Column, Checkbox, Bleed } from '@machobear/design-system'
import { useTranslation } from 'react-i18next'
import Illustration from '../images/no-listings-illustration.svg?react'

const EmptyAttachedList = ({ heading }: { heading: string }) => {
  const { t } = useTranslation()

  return (
    <Bleed horizontal="small" vertical="xlarge">
      <Box
        background="tableBodyAlternate"
        paddingX="xsmall"
        paddingY="xsmall"
        role="columnheader"
        borderTopRightRadius="large"
        borderTopLeftRadius="large"
        borderBottom="borderNeutralLight"
      >
        <Columns space="none" alignY="center">
          <Column width="content">
            <Box display="flex" alignItems="center">
              <Checkbox id="select-all" onChange={() => {}} checked={false} disabled label="" />
              <Text size="small" weight="strong">
                {heading}
              </Text>
            </Box>
          </Column>
        </Columns>
      </Box>

      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="full"
        marginTop="xxlarge"
      >
        <Stack align="center" space="medium">
          <Illustration />
          <Text size="standard" weight="medium">
            {t('l.settings.view.auto_reply.no_listings_assigned', 'No listings assigned')}
          </Text>
          <Box maxWidth="small">
            <Text size="small" weight="regular" align={'center'}>
              {t(
                'l.settings.view.auto_reply.listings_assigned_displayed',
                'All listings assigned to this message will be displayed here'
              )}
            </Text>
          </Box>
        </Stack>
      </Box>
    </Bleed>
  )
}

export default EmptyAttachedList
